import {useEffect, useState} from "react";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import SurveyParticipantsGridContainer from "../containers/SurveyParticipantsGridContainer";
import SurveyOverviewParticipantSelector from "../components/SurveyOverviewParticipantSelector";
import SurveyOverviewResendSelector from "../components/SurveyOverviewResendSelector";
import SurveyUpdateParticipants from "../components/SurveyUpdateParticipants"
import GenericDialog from "../components/GenericDialog";
import DeleteDialog from "../components/DeleteDialog";
import Slider from "../components/Slider";
import surveys_api from "../api/protected/surveys";
import people_api from "../api/protected/people";
import DatePicker from "react-datepicker";
import types from "../assets/constants/types";
import overviewIcon from "../assets/overview.svg";
import deleteIcon from "../assets/delete-icon.svg";
import back_arrow from "../assets/backarrow.svg";
import editIcon from "../assets/edit.png";
import info from "../assets/info-icon.png";
import expand from "../assets/expand-teams.svg";
import collapse from "../assets/collapse.svg";
import EditTeamLatestSurveyContainer from "../components/EditTeamLatestSurveyContainer";
import SurveyUpdateDetails from "../components/SurveyUpdateDetails";


const EditSurvey = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    const [surveyId, setSurveyId] = useState()
    const [isDemo, setIsDemo] = useState(false)
    const [returnToTeam, setReturnToTeam] = useState(false)

    const [selectedPeople, setSelectedPeople] = useState([]);
    const [survey, setSurvey] = useState();
    const [people, setPeople] = useState();
    const [totalCompleted, setTotalCompleted] = useState(2);
    const [editor, setEditor] = useState(false);

    const [showDelete, setShowDelete] = useState();
    const buttons = [{"text":"Delete", "id": "1"}, {"text":"Cancel", "id": "2"}];

    const [showDeleteHover, setShowDeleteHover] = useState(false)
    const [showOverviewHover, setShowOverviewHover] = useState(false)
    const [showHidden, setShowHidden] = useState(false)

    const [showParticipantSelection, setShowParticipantSelection] = useState(false)
    const [showInsufficientResponses, setShowInsufficientResponses] = useState(false)

    const [newlySelected, setNewlySelected] = useState([])
    const [showPopup, setShowPopup] = useState(false)

    const [showResendPopup, setShowResendPopup] = useState(false)
    const [showResendConfirmation, setShowResendConfirmation] = useState(false)
    const [resendPopupTitle, setResendPopupTitle] = useState("")
    const [resendPopupText, setResendPopupText] = useState("")

    const [showParticipantsHover, setShowParticipantsHover] = useState(false)
    const [detailsCollapsed, setDetailsCollapsed] = useState(true)
    const [participantCollapsed, setParticipantCollapsed] = useState(false)

    const [resendList, setResendList] = useState([])
    const [newEmailList, setNewEmailList] = useState([])
    const [showNewSendConfirmation, setShowNewSendConfirmation] = useState(false)

    const [showSurveyUpdateDetails, setShowSurveyUpdateDetails] = useState(false)
    const [showSurveyUpdateHover, setShowSurveyUpdateHover] = useState(false)


    useEffect(() => {
        if(searchParams.get('demo')) {
            setIsDemo(true)
        }
        if(searchParams.get('return')) {
            setReturnToTeam(true)
        }
        setSurveyId(params.surveyId)
    }, []);

    useEffect(() => {
        if(!people || !selectedPeople) return;
        establishMailLists()
    }, [people, selectedPeople]);

    useEffect(() => {
        if(!survey) return;
        let response = surveys_api.putSurveyVisibility(surveyId, {"hidden": showHidden})
        response.then(() => {}).catch(err => console.log(err))
    }, [survey, showHidden])

    const disabled_date = (surveyDate) => new Date() < surveyDate;

    const GetSurvey = () => {
        let response;
        if(isDemo) {
            response = surveys_api.getDemoSurvey(surveyId);
        } else {
            response = surveys_api.getSurvey(surveyId);
        }
        response.then(response => {
            setSurvey(response.data.surveys[0]);
            setEditor(response.data.surveys[0].editor)
            setSelectedPeople(response.data.participants);
            setTotalCompleted(response.data.participants.filter((p) => p.percentage_complete === 100).length);
            getPeople(response.data.surveys[0].team_id)
        })
    }

    const getPeople = (team_id) => {
        let response;
        if(isDemo) {
            response = people_api.getDemoPeopleFromSurvey(team_id, surveyId);
        } else {
            response = people_api.getPeopleFromSurvey(team_id, surveyId);
        }
        response.then(response => {
            setPeople(response.data.people);
        })
    }

    const handleDeleteClick = () => {
        setShowDelete(!showDelete)
    }

    const handleSurveyUpdateClick = (showDetails, refresh = false) => {
        setShowSurveyUpdateDetails(showDetails)
        if (refresh) GetSurvey()
    }

    const handleOverviewClick = () => {
        if (totalCompleted < 2) {
            handleInsufficientPopup()
        } else {
            setShowParticipantSelection(true)
        }
    }

    const handleDeleteResult = (result) => {
        if (result === "1") deleteSurvey();
        setShowDelete(false)
    }

    const handleNewlySelected = (result) => {
        if (!result) return;
        if (result === "1") updateSurvey();
        setShowPopup(false)
    }

    const deleteSurvey = () => {
        let response = surveys_api.deleteSurvey(surveyId);
        response.then(() => navigate("/surveys")).catch(() => console.log("Failed to delete survey"))
    }

    const handleDeleteHoverOn = () => {
        setShowDeleteHover(true)
    }

    const handleDeleteHoverOut = () => {
        setShowDeleteHover(false)
    }

    const handleClickHoverOn = () => {
        setShowOverviewHover(true)
    }

    const handleClickHoverOut = () => {
        setShowOverviewHover(false)
    }

    const handleSurveyUpdateHoverOn = () => {
        setShowSurveyUpdateHover(true)
    }

    const handleSurveyUpdateHoverOut = () => {
        setShowSurveyUpdateHover(false)
    }

    const updateSurvey = () => {
        let body = {
            "team_id": survey.team_id,
            "name": survey.survey_name,
            "expiry_date": survey.expiry_date,
            "participants": selectedPeople
        }

        let response = surveys_api.updateSurvey(survey.id, body);
        response.then(() => navigate("/surveys")).catch(() => console.log(body))
    }

    const updateToggleHidden = () => {
        setShowHidden(!showHidden);
    }

    const handleFooter = (result) => {
        if (!result) return;
        if (result.button === "1") {
            if (result.people.length > 1) {
                let selectedURL = "["
                for (let i = 0; i < result.people.length; i++) {
                    let participant_id = result.people[i].id
                    selectedURL += participant_id + ","
                }
                selectedURL = selectedURL.substring(0, selectedURL.length - 1) + "]";
                if(isDemo) {
                    navigate(`/diagnostic_summary/${surveyId}?selected=${selectedURL}&demo=true`);
                } else {
                    navigate(`/diagnostic_summary/${surveyId}?selected=${selectedURL}`);
                }
            } else alert("Please select two or more participants.");
        } else setShowParticipantSelection(!showParticipantSelection);
    }

    const handleInsufficientPopup = () => {
        setShowInsufficientResponses(!showInsufficientResponses)
        setShowParticipantSelection(false)
    }

    const getSurveyName = () => {
        let name = `${survey.organisation_name}, ${survey.team_name}, ${types.point_types.find(x => x.id === survey.survey_point).name}`

        if(!name) return "Edit Survey"
        if(survey.survey_point < 4) name += " Point"
        return name
    }

    const resendEmails = (people) => {
        let ppl = []
        for (const person of people) ppl.push(person.person_id);

        let response = surveys_api.resendEmails(surveyId, ppl)
        response.then(() => {
            setResendPopupTitle("Invitations Sent")
            setResendPopupText("The invitation emails have been sent successfully.")
            setShowResendPopup(true)
        }).catch(() => {
            setResendPopupTitle("Emails Failed")
            setResendPopupText("There has been an error trying to resend the emails. Please try again")
            setShowResendPopup(true)
        })
    }

    const handleResendConfirmation = (res) => {
        setShowResendConfirmation(false)
        setShowNewSendConfirmation(false)
        if(res.button === "1") {
            resendEmails(selectedPeople)
        }
    }

    useEffect(() => {
        if (!surveyId) return;
        GetSurvey()
    }, [surveyId]);

    useEffect(() => {
        if (!survey) return;
        if (survey.hidden === 0) {
            setShowHidden(false)
        } else {
            setShowHidden(true)
        }
    }, [survey]);

    useEffect(() => {
        if (searchParams.get("overview")) {
            setSearchParams(searchParams)
            if (totalCompleted < 2) {
                handleInsufficientPopup()
            } else {
                setShowParticipantSelection(true)
            }
        }
    },[totalCompleted])

    const handleResendPopup = () => {
        setShowResendPopup(false)
        setResendPopupTitle("")
        setResendPopupText("")
    }

    const establishMailLists = () => {
        let resend = []
        let new_email = []
        for(const p of selectedPeople) {
            if (p?.sent) resend.push({...p,  "person_id": p.id})
        }
        setResendList(resend)

        for(const p of people) {
            let idx = selectedPeople.findIndex(x => x.person_id === p.id);
            if(!selectedPeople[idx]?.sent) {
                new_email.push({...p, "person_id": p.id})
            }
        }
        setNewEmailList(new_email)
    }

    const handleNewSendClick = (ev) => {
        if(!ev) return;
        setShowNewSendConfirmation(true)
    }

    const handleReturn = () => {
        if (window.history.length > 1) {
            navigate(-1)
        } else if (returnToTeam) {
            navigate("/teams/" + survey.team_id)
        }
        else {
            navigate("/surveys")
        }
    }

    return (
            <div className="surveys-page-background-container">
                <div className="surveys-page-container">
                    {!showSurveyUpdateDetails ?
                        <>
                            <div className="back-link link" onClick={() => handleReturn()}>
                                <img className={"back-arrow-classname"} src={back_arrow} alt={"Back Arrow"}/>
                            </div>
                            {survey && survey ?
                                <>
                                    <div className="surveys-page-header">
                                        <div className="surveys-page-title blue">
                                            {getSurveyName()} {survey.draft ?
                                            <span className="survey-page-draft">(draft)</span> : null}
                                        </div>
                                        <div className="col">
                                            <div className="header-icon-container">
                                                {editor ?
                                                    <div className="header-survey-update-container" onMouseOver={handleSurveyUpdateHoverOn}
                                                         onClick={() => handleSurveyUpdateClick(true, false)} onMouseLeave={handleSurveyUpdateHoverOut}>
                                                        <img className="header-survey-update-icon link" src={editIcon}
                                                             alt="Update Survey Details"/>
                                                        {showSurveyUpdateHover ?
                                                            <div className="survey-update-tooltip-container">
                                                                <div className="survey-update-tooltip-text">Update Survey Details</div>
                                                            </div> : null
                                                        }
                                                    </div> : null
                                                }
                                                {editor ?
                                                    <>
                                                        <div className="header-slider-container">
                                                            <Slider update={updateToggleHidden.bind(this)} state={showHidden}
                                                                    type="Survey"/>
                                                            <div className="header-hide-text">Hide</div>
                                                        </div>
                                                    </> : null
                                                }
                                                <img className="header-overview-icon link" src={overviewIcon} alt="overview icon"
                                                     onClick={handleOverviewClick} onMouseOver={handleClickHoverOn}
                                                     onMouseLeave={handleClickHoverOut}/>
                                                {showOverviewHover ?
                                                    <div className="delete-tooltip-container overview">
                                                        <div className="delete-tooltip-text">Diagnostic Summary</div>
                                                    </div> : null
                                                }
                                                {editor ?
                                                    <div className="header-delete-container" onMouseOver={handleDeleteHoverOn}
                                                         onClick={handleDeleteClick} onMouseLeave={handleDeleteHoverOut}>
                                                        <img className="header-delete-icon link" src={deleteIcon}
                                                             alt="Delete Survey"/>
                                                        {showDeleteHover ?
                                                            <div className="delete-tooltip-container">
                                                                <div className="delete-tooltip-text">Delete Survey</div>
                                                            </div> : null
                                                        }
                                                    </div> : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="survey-form-container">
                                        <div className={`survey-form-title flexed ${detailsCollapsed ? "collapsed" : ""}`}
                                             onClick={() => setDetailsCollapsed(!detailsCollapsed)}>
                                            Survey Details
                                            <img src={detailsCollapsed ? expand : collapse}
                                                 alt={detailsCollapsed ? "Show Details" : "Hide Details"}/>
                                        </div>
                                        {!detailsCollapsed ?
                                            <EditTeamLatestSurveyContainer survey={{...survey, "participants": selectedPeople}}  isDemo={isDemo}
                                                                           team_id={survey.team_id}/>
                                            : null
                                        }
                                    </div>
                                    <div className="survey-form-container">
                                        <div className="survey-form-title-container">
                                            <div className="survey-form-title info-popup">
                                                Manage Team Member & Stakeholder Participants
                                                <img src={info} alt="Info"
                                                     onMouseOver={() => setShowParticipantsHover(true)}
                                                     onMouseLeave={() => setShowParticipantsHover(false)}
                                                />
                                                {showParticipantsHover ?
                                                    <div className="dashboard-roi-title-hover" style={{top: 40, left: 470}}>
                                                        <div className="dashboard-roi-title-hover-triangle-outer">
                                                            <div className="dashboard-roi-title-hover-triangle-inner"/>
                                                        </div>
                                                        <div className="dashboard-roi-title-hover-text regular">
                                                            This section allows you to manage this survey by viewing the invitation
                                                            status, send the survey invitation to additional participants and to
                                                            resend
                                                            surveys.
                                                            <br/><br/>
                                                            If you wish to add, edit or permanently remove any Team and Stakeholder
                                                            members please do so in the Team Page.
                                                            <br/><br/>
                                                            If you wish to simply exclude any team or stakeholder member responses
                                                            from
                                                            this survey, you are advised to exclude them when you run the report.
                                                        </div>
                                                    </div> : null
                                                }
                                            </div>
                                            <img src={participantCollapsed ? expand : collapse}
                                                 className={participantCollapsed ? `survey-form-title-collapse` : ""}
                                                 alt={participantCollapsed ? "Show Participants" : "Hide Participants"}
                                                 onClick={() => setParticipantCollapsed(!participantCollapsed)}
                                            />
                                        </div>
                                        {!participantCollapsed ?
                                            <>
                                                <SurveyParticipantsGridContainer people={people} selectedPeople={selectedPeople}
                                                                                 updateSelected={setSelectedPeople.bind(this)}
                                                                                 newlySelected={newlySelected}
                                                                                 updateNewlySelected={setNewlySelected.bind(this)}
                                                                                 editor={editor}
                                                                                 isDemo={isDemo}
                                                />
                                                {editor ?
                                                    <div className="field-input flexed">
                                                        <button
                                                            className={`update-organisation-button link ${!newEmailList.length ? "disabled" : ""}`}
                                                            onClick={handleNewSendClick} disabled={!newEmailList.length}>
                                                            SEND INVITATIONS
                                                        </button>
                                                        <button className="update-organisation-button link"
                                                                onClick={() => navigate(`/teams/${survey.team_id}`)}>
                                                            SEE TEAM PAGE
                                                        </button>
                                                    </div> : null
                                                }
                                            </> : null
                                        }
                                    </div>
                                </> : null
                            }
                            {showDelete ?
                                <DeleteDialog title="Delete Survey" type="Survey" name={"Do you want to delete this survey?"}
                                              description={survey.survey_description && survey.survey_description}
                                              buttons={buttons} result={handleDeleteResult.bind(this)}/>
                                : null
                            }
                            {showParticipantSelection ?
                                <SurveyOverviewParticipantSelector people={selectedPeople} result={handleFooter.bind(this)}
                                /> : null
                            }
                            {showPopup ?
                                <SurveyUpdateParticipants people={newlySelected} result={handleNewlySelected.bind(this)}
                                                          cancel_text="Cancel"
                                /> : null
                            }
                            {showInsufficientResponses ?
                                <GenericDialog title="Diagnostic Summary"
                                               text="Insufficient responses have been received, two or more completed responses needed."
                                               buttons={[{"text": "OK", "id": "1"}]} result={handleInsufficientPopup.bind(this)}
                                /> : null
                            }
                            {showResendPopup ?
                                <GenericDialog title={resendPopupTitle} text={resendPopupText}
                                               buttons={[{"text": "OK", "id": "1"}]} result={handleResendPopup.bind(this)}
                                /> : null
                            }
                            {showResendConfirmation ?
                                <SurveyOverviewResendSelector result={handleResendConfirmation.bind(this)}
                                /> : null
                            }
                            {showNewSendConfirmation ?
                                <SurveyOverviewResendSelector people={selectedPeople} result={handleResendConfirmation.bind(this)}
                                /> : null
                            }
                        </> : <SurveyUpdateDetails survey={survey} people={selectedPeople} isDemo={isDemo} result={(show, refresh) => handleSurveyUpdateClick(show, refresh)} isDraft={survey.draft}/>
                    }
                </div>
            </div>
    )
}

export default EditSurvey;
